import React, { FC, useCallback, useMemo } from 'react';
import { Tag, Button, Popconfirm, Switch, Row } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { ROLE_TYPES } from '../../utils/DataConstants';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { nullSafeGet } from '../../utils/DataAccessUtils';

require('./SavedFilterViewsRowDisplay.less');

interface SavedViewRowDisplayProps {
	record: any;
	isAdmin: Boolean;
	onOpenView: (view) => void;
	onDelete: (record) => void;
	setDefault: any;
	isDefault: Boolean;
	allowSetDefault: Boolean;
	userType: any;
}

const SavedFilterViewsRowDisplay: FC<SavedViewRowDisplayProps> = ({
	record,
	isAdmin,
	onOpenView,
	onDelete,
	setDefault,
	isDefault,
	allowSetDefault = false,
	userType,
}): React.ReactElement => {
	const applyFilter = useCallback(() => {
		record && onOpenView && onOpenView(record);
	}, [record, onOpenView]);

	const isDeletetableView = useMemo(() => !record.isPublic || isAdmin, [isAdmin, record]);

	const onConfirmDelete = useCallback(() => {
		onDelete && onDelete(record);
	}, [record, onDelete]);

	return (
		<Row className={'SavedViewDisplayRow'} style={{ width: '100%' }}>
			<div
				style={{
					maxWidth: '80%',
					display: 'flex',
					flexDirection: 'row',
				}}
			>
				<span
					style={{
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
					}}
				>
					<Ellipsis tooltip={true} length={50}>
						{record.name}
					</Ellipsis>
				</span>
				{record.isPublic && (
					<span>
						<Tag style={{ marginLeft: 8 }}>Public</Tag>
					</span>
				)}
				{isDefault && (
					<span>
						<Tag
							style={{ marginLeft: 4 }}
							color={userType === ROLE_TYPES.SUPPLIER ? '#2792b0' : '#6027b0'}
						>
							Default
						</Tag>
					</span>
				)}
			</div>
			<div style={{ flex: 1 }} />
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center',
				}}
			>
				{allowSetDefault ? (
					isDefault ? (
						<Button
							type={'link'}
							style={{ marginRight: 8, marginLeft: 8 }}
							onClick={() => setDefault(record.id)}
						>
							Clear Default
						</Button>
					) : (
						<span className={'SetDefaultButton'}>
							<Button type={'link'} onClick={() => setDefault(record.id)}>
								Set Default
							</Button>
						</span>
					)
				) : null}
				<Button onClick={applyFilter}>Open</Button>
				{isDeletetableView ? (
					<Popconfirm
						onConfirm={onConfirmDelete}
						title="Are you sure you want to delete this view?"
						okText="Yes"
						cancelText="No"
					>
						<DeleteOutlined style={{ marginLeft: 8 }} translate="" />
					</Popconfirm>
				) : (
					<div style={{ width: 22 }} />
				)}
			</div>
		</Row>
	);
};

export default SavedFilterViewsRowDisplay;
